import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useMembersStore } from '../store/membersStore'
import { deleteMember } from '../utils/deleteMember'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useDeleteMemberMutation = (onSuccess?: () => void) => {
  const remove = useMembersStore((state) => state.remove)

  return useMutation({
    mutationFn: deleteMember,
    onSuccess: ({ message, id }) => {
      remove(id)
      toast.success(message || 'Member deleted successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while deleting member.')
    },
  })
}
